import "./LoginPrompt.scss";

import * as React from "react";
import { Modal } from "react-bootstrap";
import _ from "lodash";

import { connect } from "../../stores";
import * as TrackingUtil from "../../utils/TrackingUtil";

import PromptCreative from "./PromptCreative";
import { CreativeElement } from "../../datatypes/Creatives";
import { StructuredTrackingData, TrackingTags } from "../../datatypes/Tracking";
import { withReactAdapter } from "../../module-federation/withReactAdapter";

type Props = {
    pageName?: string;
    cookiesAllowed: boolean | undefined;
    loginPromptCreative: CreativeElement[];
    loginPromptCapped: boolean | undefined;
    loggedIn: boolean;
    dismissLoginPrompt: RefluxAction<[]>;
    container: React.Component<any>;
};

export class LoginPrompt extends React.Component<Props> {
    getTrackingData(): StructuredTrackingData {
        const pageName = this.props.pageName ? this.props.pageName : undefined;
        const tags: TrackingTags = { page: pageName };
        return {
            tags: tags
        };
    }

    handleClose = () => {
        this.props.dismissLoginPrompt.trigger();
    };

    handleDismiss = () => {
        TrackingUtil.trackStructuredEvent("loginprompt.dismiss", this.getTrackingData());
        this.handleClose();
    };

    render() {
        const creative = this.props.loginPromptCreative;
        // in these cases just don't render at all
        if (!creative || _.isEmpty(creative) || this.props.loggedIn) {
            return null;
        }
        // otherwise do proper transitions
        const showPrompt: boolean | undefined = this.props.cookiesAllowed && !this.props.loginPromptCapped;
        if (showPrompt) {
            TrackingUtil.trackStructuredEvent("loginprompt.show", this.getTrackingData());
        }
        return (
            <Modal
                container={this.props.container}
                className="mfcss ex-login-prompt"
                keyboard
                show={showPrompt}
                onHide={this.handleDismiss}>
                <Modal.Body>
                    <PromptCreative
                        creative={this.props.loginPromptCreative}
                        onClick={this.handleClose}
                        onDismiss={this.handleDismiss}
                    />
                </Modal.Body>
            </Modal>
        );
    }
}

const wrapped = connect(
    {
        stores: {
            SessionStore: (store: any) => ({ country: store.loggedIn() }),
            PromptStore: (s: any) => ({
                cookiesAllowed: s.getCookiesAllowed(),
                loginPromptCreative: s.getLoginPromptCreative(),
                loginPromptCapped: s.getLoginPromptCapped()
            })
        },
        actions: {
            PromptActions: ["dismissLoginPrompt"]
        }
    },
    LoginPrompt
);

export default withReactAdapter(wrapped);
